import React from 'react';
interface RatioTableProps {
  headers: string[];
  rows: Array<Array<string | number>>;
  highlightRow?: number;
  highlightCol?: number;
}
export function RatioTable({
  headers,
  rows,
  highlightRow,
  highlightCol
}: RatioTableProps) {
  return <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 overflow-x-auto" data-id="element-6054">
      <table className="w-full border-collapse" data-id="element-6055">
        <thead data-id="element-6056">
          <tr data-id="element-6057">
            {headers.map((header, i) => <th key={i} className={`p-3 text-left font-bold border-b-2 ${highlightCol === i ? 'bg-indigo-100 border-indigo-300 text-indigo-900' : 'bg-slate-100 border-slate-300 text-slate-700'}`} data-id="element-6058">

                {header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-6059">
          {rows.map((row, rowIndex) => <tr key={rowIndex} className={highlightRow === rowIndex ? 'bg-indigo-50' : 'bg-white'} data-id="element-6060">

              {row.map((cell, cellIndex) => <td key={cellIndex} className={`p-3 border-b border-slate-200 ${highlightRow === rowIndex || highlightCol === cellIndex ? 'font-bold text-indigo-900' : 'text-slate-700'}`} data-id="element-6061">

                  {cell}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}